import { Button, Form, Input } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/auth'
import { useCallback } from 'react'

export const Login = () => {
    const navigate = useNavigate()
    const { signIn } = useAuth()

    const onFinish = useCallback(
        (values: any) => {
            signIn(
                values,
                () => {
                    navigate('/')
                },
                () => {}
            )
        },
        [navigate, signIn]
    )

    const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo)
    }

    return (
        <Form
            name='basic'
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ maxWidth: 1000 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
        >
            <Form.Item label='E-mail' name='email' rules={[{ required: true, message: 'Please input your E-mail!' }]}>
                <Input />
            </Form.Item>

            <Form.Item
                label='Password'
                name='password'
                rules={[{ required: true, message: 'Please input your password!' }]}
            >
                <Input.Password />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type='primary' htmlType='submit'>
                    Submit
                </Button>
            </Form.Item>
        </Form>
    )
}
